import React from 'react'
import { fundebugInit, fundebugNotifyError } from '../util/fundebugUse'

// Fundebug初始化
fundebugInit()

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidCatch(error, errorInfo) {
    console.log('error==>', error, errorInfo)
  }
  // componentDidCatch(error, info) {
    // 将component中的报错发送到Fundebug
    // fundebugNotifyError(error, info)
  // }
  render() {
    return this.props.children
  }
}

export default ErrorBoundary
